document.addEventListener("DOMContentLoaded",
                          function() {
  var div, n,
      v = document.getElementsByClassName("youtube-player");
  for (n = 0; n < v.length; n++) {
    div = document.createElement("div");
    div.setAttribute("data-id", v[n].dataset.id);
    div.innerHTML = labnolThumb(v[n].dataset.id);
    div.onclick = labnolIframe;
    v[n].appendChild(div);
  }
});

function labnolThumb(id) {
  var thumb = '<img data-src="https://i.ytimg.com/vi/ID/hqdefault.jpg" class="lazyload">',
      play = '<div class="play"></div>';
  return thumb.replace("ID", id) + play;
}

function labnolIframe() {
  var iframe = document.createElement("iframe");
  var embed = "https://www.youtube.com/embed/ID?autoplay=1&rel=0";
  iframe.setAttribute("src", embed.replace("ID", this.dataset.id));
  iframe.setAttribute("frameborder", "0");
  iframe.setAttribute("allowfullscreen", "1");
  this.parentNode.replaceChild(iframe, this);
}

  $('body').on('click','#mobile_menu li.sublink a.parent-link--true',function(event){
    event.preventDefault();
    
    $(".sublink").each(function( index ) {     
     	$('.sublink ul').hide();     
    });
    
      if(!$(this).next('ul').hasClass("bmone")) {
        $(".sublink").each(function( index ) {     
     		$('.sublink ul').removeClass('bmone');     
    	});
        
     	$(this).next('ul').show('slow');
    	$(this).next('ul').addClass('bmone');
      } else{ 
        $(this).next('ul').hide('slow');
    	$(this).next('ul').removeClass('bmone');
      }
   
    
  });

$(function() {
var pkey = localStorage.getItem("epicwatchbands.com_pkey");
var hash = localStorage.getItem("epicwatchbands.com_hash");  

  $('#epic-key').val(pkey);
  $('#epic-hash').val(hash);
 
   $('.stamped-lazyload').attr({ width: '100%', height: '100%' }); 
  setTimeout(function() { 
   $('#review_header').find('img').attr({ width: '100%', height: '100%' }); 
   $('#review_image').find('img').attr({ width: '100%', height: '100%' }); 
    $('.fomo-notification-image').attr({ width: '100%', height: '100%' }); 
    }, 2000);
  $('.frequently_asked_image').find('img').attr({ width: '100%', height: '100%' });  

  
  $( "#mobile-dropdown" ).click(function() { 
     $('.menu-toggle-section').toggleClass('open');
     $('#mobile-dropdown-contents').toggle();
    
  });
  $('html').on('click', function(event) {
  if (!$(event.target).closest('#mobile-dropdown-contents').length && !$(event.target).closest('#mobile-dropdown').length) {
    $('#mobile-dropdown-contents').hide();
    $('.menu-toggle-section').removeClass('open');
  }
});

  //$(".selector-section").children().eq(1).addClass("video-player");
 $(".selector-section").children().eq(1).find('label:contains("For Apple Watch")').closest('.selector-wrapper').addClass('video-player');
   
  $("<div id='youtube-play' class='active hover-text'><span class='tooltip-text' id='right'>Not sure what size you need? <u>Learn More</u></span> <a class='fancybox' id='youtube-box'  href='https://www.youtube.com/watch?v=3DY5bnou_Po'><img src='https://cdn.shopify.com/s/files/1/2097/2189/files/help.png'></a></div>").insertAfter(".video-player label").children().eq(1);
$(".selector-section").children().eq(1).find('label').click(function(event){
  event.preventDefault();
   $(".fancybox").fancybox({
        helpers: {
            media: true
        },
        youtube: {
            autoplay: 1,
            start: 0 
        }
    }); 
   $(".fancybox").trigger('click');  
  if($(window).width() <=768) {
  $( "#youtube-box" ).trigger('click'); 
  }
})
  $( window ).resize(function() {
    detectClick();
  });
detectClick();
  var clicks = 1;
  function detectClick(){
     if($(window).width() <=768) {

$('#youtube-box').click(function(ev) {
  ev.preventDefault();
});

$('#youtube-play').click(function(ev) {
  ev.preventDefault();
  console.log('clicks'+clicks);
  $(".fancybox").unbind('click');
    if (clicks%2 == 0){
       ++clicks;
        // second click
        $(".fancybox").fancybox({
        helpers: {
            media: true
        },
        youtube: {
            autoplay: 1,
            start: 0 
        }
    })
       $(".fancybox").trigger('click');
    } else{
       ++clicks;
     
        // first click
     
    }
  
   
});

 }
  else {
     $(".fancybox").fancybox({
        helpers: {
            media: true
        },
        youtube: {
            autoplay: 1,
            start: 0 
        }
    }); 
  }
  }
  
});